import { SubmitEvent, useState } from 'react'
import { Title } from '@shared/ui/Typography/Title'
import s from './RegistrationForm.module.sass'
import { useField } from '@shared/lib/fields/hooks/useField/useField'
import { getField, RegFormFields } from '@pages/OwnerLanding/RegistrationForm/Forms/fields'
import { BuildInput } from '@shared/ui/Form/Build/BuildInput'
import { Button } from '@shared/ui/Actions/Button'
import { Checkbox } from '@shared/ui/Form/Single/Checkbox'
import Link from '@shared/ui/Navigation/Link'
import { useSearchParams } from 'next/navigation'

interface Props {
  defaultState: Partial<Record<RegFormFields, string>>
  onSubmit?: (state: Partial<Record<RegFormFields | 'discount_promo', string>>) => void
}

export const RegistrationForm = ({ defaultState, onSubmit }: Props) => {
  const searchParams = useSearchParams()
  const hasPromoActive =
    searchParams.get('special') === 'gastreet2026' || searchParams.get('special') === 'telemarketing'

  const handleSubmit = (e: SubmitEvent<HTMLFormElement>) => {
    e.stopPropagation()
    e.preventDefault()
    onSubmit &&
      onSubmit({
        [RegFormFields.personName]: personName.value,
        [RegFormFields.phone_contact]: phone.value,
        [RegFormFields.email]: email.value,
        // "Персональная скидка и пометки для особых видов пользователей
        discount_promo: hasPromoActive ? searchParams.get('special') : undefined,
      })
  }

  const [personName, setPersonName] = useField(
    getField(RegFormFields.personName, defaultState[RegFormFields.personName]),
  )
  const [phone, setPhone] = useField(getField(RegFormFields.phone_contact, defaultState[RegFormFields.phone_contact]))
  const [email, setEmail] = useField(getField(RegFormFields.email, defaultState[RegFormFields.email]))

  const [isAgreed, setAgreed] = useState(false)

  const isSubmitAllowed =
    [personName, phone, email].reduce((acc, field) => {
      return acc && !!field?.valid
    }, true) && isAgreed

  return (
    <form className={s.form} onSubmit={handleSubmit}>
      <Title tag='h1' sizes='h1 h2' className={s.title}>
        Регистрация для&nbsp;рестораторов
      </Title>

      <div className={s.content}>
        <BuildInput field={personName} setField={setPersonName} />
        <div className={s.row}>
          <BuildInput field={phone} setField={setPhone} />
          <BuildInput field={email} setField={setEmail} />
        </div>
      </div>

      <div className={s['submit-block']}>
        <div className={s['checkbox-line']} onClick={() => setAgreed((old) => !old)}>
          <Checkbox
            mode={'checkbox'}
            option={{
              id: 'agreement',
              name: 'agreement',
            }}
            checked={isAgreed}
            onChange={() => setAgreed((old) => !old)}
          />
          <span>
            Даю{' '}
            <Link
              href='https://www.afisha.ru/article/privacy-policy/'
              target={'_blank'}
              className={s.link}
              onClick={(e) => e.stopPropagation()}>
              согласие
            </Link>{' '}
            на обработку персональных данных
          </span>
        </div>

        <Button type='submit' className={s['next-button']} sizes={'XL'} mode='black' disabled={!isSubmitAllowed}>
          Далее
        </Button>
      </div>
    </form>
  )
}
